// import { Fragment, useLayoutEffect, useMemo } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { useChatApi } from '../Services/ChatApiProvider';
// import TypingIndicator from './TypingIndicator';
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import rehypeRaw from "rehype-raw";
// import assistantAvatar1 from '../media/assist1.svg';

// import {
//   AssistantHeaderMessage,
//   MediaMessageBotURL,
//   MediaMessageBotImage,
//   MediaMessageBotAudio,
//   MediaMessageBotFile,
//   MediaMessageBotVideo,
//   MediaMessageBotHTML,
//   MediaMessageUserURL,
//   MediaMessageUserImage,
//   MediaMessageUserAudio,
//   MediaMessageUserFile,
//   MediaMessageUserVideo,
//   MediaMessageUserHTML,
//   MediaMessageUserSending,
// } from './MessageComponents';

// const ChatMessages = ({ isChatActive, scrollContainerRef }) => {
//   const { messages, isTyping } = useChatApi(); // ⬅ removed isSendingImages (not provided by context)

//   // Stick to bottom on new messages / typing changes
//   useLayoutEffect(() => {
//     const el = scrollContainerRef?.current;
//     if (!el) return;
//     el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
//   }, [messages, isTyping, scrollContainerRef]);

//   const items = messages; // alias to avoid re-typing

//   return (
//     <>
//       <AnimatePresence>
//         {isChatActive && (
//           <motion.div
//             key="chat-messages-container"
//             className="chat-messages"
//             exit={{ opacity: 0 }}
//             transition={{ duration: 0.3 }}
//           >
//             {items.map((msg, index) => {
//                 console.log('message - ',msg);
//               if (msg.newassistant) {
//                 return (
//                   <Fragment key={msg.id}>
//                     <AssistantHeaderMessage message={msg} />
//                   </Fragment>
//                 );
//               }

//               const rawSender = (msg.sender || '').toString().toLowerCase();
//               const isAssistant =
//                 rawSender === 'assistant' || rawSender === 'bot' || rawSender === 'system' || msg.intro === 'true';

//               const nextRawSender = ((items[index + 1]?.sender) || '').toString().toLowerCase();
//               const nextMsgIsAssistant =
//                 nextRawSender === 'assistant' || nextRawSender === 'bot' || nextRawSender === 'system';

//               const isFirstUserMsg =
//                 msg.sender === 'user' && (index === 0 || items[index - 1]?.sender !== 'user');
//               const isLastUserMsg =
//                 msg.sender === 'user' && (index === items.length - 1 || items[index + 1]?.sender !== 'user');
//               const isMiddleUserMsg = msg.sender === 'user' && !isFirstUserMsg && !isLastUserMsg;
//               const isOnlyUserMsg = isFirstUserMsg && isLastUserMsg;

//               const isFirstAssistantMsg =
//                 msg.sender === 'assistant' && (index === 0 || items[index - 1]?.sender !== 'assistant');
//               const isLastAssistantMsg =
//                 msg.sender === 'assistant' && (index === items.length - 1 || items[index + 1]?.sender !== 'assistant');
//               const isMiddleAssistantMsg = msg.sender === 'assistant' && !isFirstAssistantMsg && !isLastAssistantMsg;
//               const isOnlyAssistantMsg = isFirstAssistantMsg && isLastAssistantMsg;

//               const groupingClasses = [
//                 isAssistant ? 'assistant' : 'user',
//                 nextMsgIsAssistant ? 'no-badge' : '',
//                 msg.sender === 'user'
//                   ? isOnlyUserMsg
//                     ? 'only-msg'
//                     : isFirstUserMsg
//                       ? 'first-user-msg'
//                       : isMiddleUserMsg
//                         ? 'middle-user-msg'
//                         : isLastUserMsg
//                           ? 'last-user-msg'
//                           : ''
//                   : isOnlyAssistantMsg
//                     ? 'only-assistant-msg'
//                     : isFirstAssistantMsg
//                       ? 'first-assistant-msg'
//                       : isMiddleAssistantMsg
//                         ? 'middle-assistant-msg'
//                         : isLastAssistantMsg
//                           ? 'last-assistant-msg'
//                           : '',
//               ].filter(Boolean).join(' ');

//               let innerContent = null;
//               const mediaType = (msg.typeOfMedia || '').toString().toLowerCase();

//               if (mediaType && mediaType !== 'simple_text') {
//                 if (isAssistant) {
//                   switch (mediaType) {
//                     case 'url':   innerContent = <MediaMessageBotURL   message={msg} />; break;
//                     case 'image': innerContent = <MediaMessageBotImage message={msg} />; break;
//                     case 'audio': innerContent = <MediaMessageBotAudio message={msg} />; break;
//                     case 'file':  innerContent = <MediaMessageBotFile  message={msg} />; break;
//                     case 'video': innerContent = <MediaMessageBotVideo message={msg} />; break;
//                     case 'html':
//                     case 'HTML':  innerContent = <MediaMessageBotHTML  message={msg} />; break;
//                     default: innerContent = null;
//                   }
//                 } else {
//                   switch (mediaType) {
//                     case 'url':   innerContent = <MediaMessageUserURL   message={msg} />; break;
//                     case 'image': innerContent = <MediaMessageUserImage message={msg} />; break;
//                     case 'audio':
//                     case 'audio_message': innerContent = <MediaMessageUserAudio message={msg} />; break;
//                     case 'file':  innerContent = <MediaMessageUserFile  message={msg} />; break;
//                     case 'video': innerContent = <MediaMessageUserVideo message={msg} />; break;
//                     case 'html':
//                     case 'HTML':  innerContent = <MediaMessageUserHTML  message={msg} />; break;
//                     case 'sending': innerContent = <MediaMessageUserSending />; break;
//                     default: innerContent = null;
//                   }
//                 }
//               } else {
//                 innerContent = (
//                   <ReactMarkdown
//                     remarkPlugins={[remarkGfm]}
//                     rehypePlugins={[rehypeRaw]}
//                     components={{
//                       a: ({ node, ...props }) => (
//                         <a {...props} target="_blank" rel="noopener noreferrer">
//                           {props.children}
//                         </a>
//                       )
//                     }}
//                   >
//                     {typeof msg.text === 'string' ? msg.text : JSON.stringify(msg.text, null, 2)}
//                   </ReactMarkdown>
//                 );
//               }

//               const bubble = (
//                 <motion.div
//                   className={`message-bubble ${isAssistant ? 'assistant-msg' : 'user-msg'} ${msg.typeOfMedia && msg.typeOfMedia !== 'simple_text' ? 'media-' + msg.typeOfMedia : ''}`}
//                   initial={{ opacity: 0, scale: 0.9, x: isAssistant ? -10 : 10 }}
//                   animate={{ opacity: 1, scale: 1, x: 0 }}
//                   exit={{ opacity: 0, scale: 0.9, x: isAssistant ? -10 : 10 }}
//                   transition={{ type: 'spring', stiffness: 200, damping: 15, duration: 0.1 }}
//                 >
//                   {innerContent}
//                 </motion.div>
//               );

//               return (
//                 <Fragment key={msg.id}>
//                   <AnimatePresence>
//                     <div className={`message-row ${groupingClasses}`}>
//                       {isAssistant && !nextMsgIsAssistant && (
//                         msg.type === 'bot' ? (
//                           msg.replacebotlogo === 'yes' ? (
//                             <img className="message-avatar" src={msg.logo || assistantAvatar1} alt="Assistant" />
//                           ) : (
//                             <motion.div
//                               className="message-avatar bot"
//                               initial={{ opacity: 0, scale: 0.5 }}
//                               animate={{ opacity: 1, scale: 1 }}
//                               exit={{ opacity: 0, scale: 0.5 }}
//                               transition={{ type: 'spring', stiffness: 200, damping: 15, duration: 0.1 }}
//                             />
//                           )
//                         ) : (
//                           <motion.img
//                             className="message-avatar"
//                             src={msg.logo || assistantAvatar1}
//                             alt="Assistant"
//                             initial={{ opacity: 0, scale: 0.5 }}
//                             animate={{ opacity: 1, scale: 1 }}
//                             exit={{ opacity: 0, scale: 0.5 }}
//                             transition={{ type: 'spring', stiffness: 200, damping: 15, duration: 0.1 }}
//                           />
//                         )
//                       )}
//                       {bubble}
//                     </div>
//                   </AnimatePresence>
//                 </Fragment>
//               );
//             })}
//             {isTyping && <TypingIndicator />}
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </>
//   );
// };

// export default ChatMessages;

import { Fragment, useLayoutEffect, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useChatApi } from '../Services/ChatApiProvider';
import TypingIndicator from './TypingIndicator';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import assistantAvatar1 from '../media/assist1.svg';

import {
  AssistantHeaderMessage,
  MediaMessageBotURL,
  MediaMessageBotImage,
  MediaMessageBotAudio,
  MediaMessageBotFile,
  MediaMessageBotVideo,
  MediaMessageBotHTML,
  MediaMessageUserURL,
  MediaMessageUserImage,
  MediaMessageUserAudio,
  MediaMessageUserFile,
  MediaMessageUserVideo,
  MediaMessageUserHTML,
  MediaMessageUserSending,
  MessageControls,
} from './MessageComponents';
import MessageReactions from './MessageReactions';

const ChatMessages = ({ isChatActive, scrollContainerRef }) => {
  // Small helper to normalize base64 → data URL (in case backend sends raw base64)
  const toDataUrl = (maybeBase64) => {
    if (!maybeBase64) return null;
    if (typeof maybeBase64 !== 'string') return null;
    if (maybeBase64.startsWith('data:image')) return maybeBase64;
    // default to png if no mime prefix provided
    return `data:image/png;base64,${maybeBase64}`;
  };

  const { messages, isTyping, channelSettings, userId, setMessageReaction, deleteMessageReaction } =
    useChatApi();
  const aiAssistantImage = toDataUrl(channelSettings?.AIassistantImage);
  const liveAssistantImage = toDataUrl(channelSettings?.liveAssistantImage);
  const secondLiveAssistantImage = toDataUrl(channelSettings?.secondLiveAssistantImage);

  const allowedReactions = channelSettings?.allowedReactions;
  const hasAllowedReactions = Array.isArray(allowedReactions) && allowedReactions.length > 0;

  // Stick to bottom on new messages / typing changes
  useLayoutEffect(() => {
    const el = scrollContainerRef?.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
  }, [messages, isTyping, scrollContainerRef]);

  const items = messages; // alias to avoid re-typing
  return (
    <>
      <AnimatePresence>
        {isChatActive && (
          <motion.div
            key="chat-messages-container"
            className="chat-messages"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {items.map((msg, index) => {
              if (msg.newassistant) {
                return (
                  <Fragment key={msg.id}>
                    <AssistantHeaderMessage message={msg} />
                  </Fragment>
                );
              }

              const rawSender = (msg.sender || '').toString().toLowerCase();
              const isAssistant =
                rawSender === 'assistant' ||
                rawSender === 'bot' ||
                rawSender === 'system' ||
                msg.intro === 'true';

              const nextRawSender = (items[index + 1]?.sender || '').toString().toLowerCase();
              const nextMsgIsAssistant =
                nextRawSender === 'assistant' ||
                nextRawSender === 'bot' ||
                nextRawSender === 'system';

              const isFirstUserMsg =
                msg.sender === 'user' && (index === 0 || items[index - 1]?.sender !== 'user');
              const isLastUserMsg =
                msg.sender === 'user' &&
                (index === items.length - 1 || items[index + 1]?.sender !== 'user');
              const isMiddleUserMsg = msg.sender === 'user' && !isFirstUserMsg && !isLastUserMsg;
              const isOnlyUserMsg = isFirstUserMsg && isLastUserMsg;

              const isFirstAssistantMsg =
                msg.sender === 'assistant' &&
                (index === 0 || items[index - 1]?.sender !== 'assistant');
              const isLastAssistantMsg =
                msg.sender === 'assistant' &&
                (index === items.length - 1 || items[index + 1]?.sender !== 'assistant');
              const isMiddleAssistantMsg =
                msg.sender === 'assistant' && !isFirstAssistantMsg && !isLastAssistantMsg;
              const isOnlyAssistantMsg = isFirstAssistantMsg && isLastAssistantMsg;

              const groupingClasses = [
                isAssistant ? 'assistant' : 'user',
                nextMsgIsAssistant ? 'no-badge' : '',
                msg.sender === 'user'
                  ? isOnlyUserMsg
                    ? 'only-msg'
                    : isFirstUserMsg
                      ? 'first-user-msg'
                      : isMiddleUserMsg
                        ? 'middle-user-msg'
                        : isLastUserMsg
                          ? 'last-user-msg'
                          : ''
                  : isOnlyAssistantMsg
                    ? 'only-assistant-msg'
                    : isFirstAssistantMsg
                      ? 'first-assistant-msg'
                      : isMiddleAssistantMsg
                        ? 'middle-assistant-msg'
                        : isLastAssistantMsg
                          ? 'last-assistant-msg'
                          : '',
              ]
                .filter(Boolean)
                .join(' ');

              let innerContent = null;
              const mediaType = (msg.typeOfMedia || '').toString().toLowerCase();

              if (mediaType && mediaType !== 'simple_text') {
                if (isAssistant) {
                  switch (mediaType) {
                    case 'url':
                      innerContent = <MediaMessageBotURL message={msg} />;
                      break;
                    case 'image':
                      innerContent = <MediaMessageBotImage message={msg} />;
                      break;
                    case 'audio':
                      innerContent = <MediaMessageBotAudio message={msg} />;
                      break;
                    case 'file':
                      innerContent = <MediaMessageBotFile message={msg} />;
                      break;
                    case 'video':
                      innerContent = <MediaMessageBotVideo message={msg} />;
                      break;
                    case 'html':
                    case 'HTML':
                      innerContent = <MediaMessageBotHTML message={msg} />;
                      break;
                    default:
                      innerContent = null;
                  }
                } else {
                  switch (mediaType) {
                    case 'url':
                      innerContent = <MediaMessageUserURL message={msg} />;
                      break;
                    case 'image':
                      innerContent = <MediaMessageUserImage message={msg} />;
                      break;
                    case 'audio':
                    case 'audio_message':
                      innerContent = <MediaMessageUserAudio message={msg} />;
                      break;
                    case 'file':
                      innerContent = <MediaMessageUserFile message={msg} />;
                      break;
                    case 'video':
                      innerContent = <MediaMessageUserVideo message={msg} />;
                      break;
                    case 'html':
                    case 'HTML':
                      innerContent = <MediaMessageUserHTML message={msg} />;
                      break;
                    case 'sending':
                      innerContent = <MediaMessageUserSending />;
                      break;
                    default:
                      innerContent = null;
                  }
                }
              } else {
                innerContent = (
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    components={{
                      a: ({ node, ...props }) => (
                        <a {...props} target="_blank" rel="noopener noreferrer">
                          {props.children}
                        </a>
                      ),
                    }}
                  >
                    {typeof msg.text === 'string' ? msg.text : JSON.stringify(msg.text, null, 2)}
                  </ReactMarkdown>
                );
              }

              const bubble = (
                <div className="message-stack">
                  <motion.div
                    className={`message-bubble ${isAssistant ? 'assistant-msg' : 'user-msg'} ${msg.typeOfMedia && msg.typeOfMedia !== 'simple_text' ? 'media-' + msg.typeOfMedia : ''}`}
                    initial={{ opacity: 0, scale: 0.9, x: isAssistant ? -10 : 10 }}
                    animate={{ opacity: 1, scale: 1, x: 0 }}
                    exit={{ opacity: 0, scale: 0.9, x: isAssistant ? -10 : 10 }}
                    transition={{ type: 'spring', stiffness: 200, damping: 15, duration: 0.1 }}
                  >
                    {innerContent}

                    {hasAllowedReactions && (
                      <MessageReactions
                        reactions={msg.reactions || []}
                        allowedReactions={allowedReactions}
                        currentUserNativeId={userId}
                        currentReactorType="user"
                        readOnly={!isAssistant}
                        onSetReaction={(reactionType) => setMessageReaction(msg.id, reactionType)}
                        onDeleteReaction={(reactionType) =>
                          deleteMessageReaction(msg.id, reactionType)
                        }
                      />
                    )}
                  </motion.div>
                </div>
              );

              return (
                <Fragment key={msg.id}>
                  <AnimatePresence>
                    <div className={`message-row ${groupingClasses}`}>
                      {isAssistant &&
                        !nextMsgIsAssistant &&
                        (['bot', 'system'].includes(msg.type) ? (
                          msg.replacebotlogo === 'yes' ? (
                            // If msg.logo present it wins, else liveAssistantImage, else fallback svg
                            <img
                              className="message-avatar"
                              src={
                                msg.logo ||
                                liveAssistantImage ||
                                secondLiveAssistantImage ||
                                assistantAvatar1
                              }
                              alt="Assistant"
                            />
                          ) : (
                            <motion.div
                              className={`message-avatar bot ${aiAssistantImage ? 'has-ai-avatar' : ''}`}
                              // If AIassistantImage exists, paint it as background and unset masks/colors
                              style={
                                aiAssistantImage
                                  ? {
                                      backgroundImage: `url(${aiAssistantImage})`,
                                    }
                                  : undefined
                              }
                              initial={{ opacity: 0, scale: 0.5 }}
                              animate={{ opacity: 1, scale: 1 }}
                              exit={{ opacity: 0, scale: 0.5 }}
                              transition={{
                                type: 'spring',
                                stiffness: 200,
                                damping: 15,
                                duration: 0.1,
                              }}
                            />
                          )
                        ) : (
                          <motion.img
                            className="message-avatar"
                            // If msg.logo present it wins, else liveAssistantImage, else fallback svg
                            src={
                              msg.logo ||
                              liveAssistantImage ||
                              secondLiveAssistantImage ||
                              assistantAvatar1
                            }
                            alt="Assistant"
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.5 }}
                            transition={{
                              type: 'spring',
                              stiffness: 200,
                              damping: 15,
                              duration: 0.1,
                            }}
                          />
                        ))}
                      {bubble}
                    </div>
                    <MessageControls controls={msg.controls} />
                  </AnimatePresence>
                </Fragment>
              );
            })}
            {isTyping && <TypingIndicator />}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ChatMessages;
